module.exports = __webpack_public_path__ + "static/media/thirdCorpUserTemp.e8937216.xlsx";